<template>
  <div class="sb-card__header" v-bind="$attrs">
    <component :is="as" v-if="title" class="sb-card__title">
      {{ title }}
    </component>
    <slot v-else></slot>
    <SbCardOptions v-if="options" :options="options" />
  </div>
</template>
<script lang="ts" setup>
import SbCardOptions from './CardOptions.vue'
import type { MenuItem } from '../Menu'

export type SbCardHeaderProps = {
  as?: 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p'
  options?: MenuItem[]
  title?: string
}

withDefaults(defineProps<SbCardHeaderProps>(), {
  as: 'span',
  options: undefined,
  title: undefined,
})
</script>
